module.exports = __webpack_public_path__ + "media/images/icons/courses/6-97e5b25016f684d2ceaa31d05c231579.svg";